import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { PhoneFormField } from '@/components/form/PhoneFormField.comp.tsx';
import { SelectSearchFormField } from '@/components/form/SelectSearchFormField.comp.tsx';
import { TextFormField } from '@/components/form/TextFormField.comp.tsx';
import { useDictionariesContext } from '@/contexts/dictionaries/Dictionaries.context.ts';
import { useGetSelectOptions } from '@/models/useGetSelectOptions.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { CreateContactFormModel } from '@/views/contactsCreate/model/CreateContactForm.model.ts';

type Props = {
  hideOwner?: boolean;
  isDisabled: boolean;
  isEditing: boolean;
};

export const ContactCreateEditFormContent: React.FC<Props> = props => {
  const { t } = useTranslationWithPrefix('views.contactsCreate');
  const { hideOwner, isDisabled, isEditing } = props;
  const { contactStatusOptions } = useGetSelectOptions();
  const [displayNameChanged, setDisplayNameChanged] = useState(false);
  const { USERS_SHORT } = useDictionariesContext();
  const formMethods = useFormContext<CreateContactFormModel>();

  const firstName = formMethods.watch('contact.firstName');
  const lastName = formMethods.watch('contact.lastName');

  useEffect(() => {
    if (displayNameChanged) {
      return;
    }
    formMethods.setValue('contact.displayName', `${firstName ?? ''} ${lastName ?? ''}`);
  }, [displayNameChanged, firstName, formMethods, lastName]);

  const handleDisplayNameChange = () => {
    setDisplayNameChanged(true);
  };

  return (
    <Grid container spacing={2} sx={{ py: 2 }}>
      <Grid size={3}>
        <TextFormField disabled={isDisabled} label={t('form.firstName')} name="contact.firstName" />
      </Grid>
      <Grid size={3}>
        <TextFormField disabled={isDisabled} label={t('form.lastName')} name="contact.lastName" />
      </Grid>
      <Grid size={3}>
        <TextFormField
          disabled={isDisabled}
          label={t('form.displayName')}
          name="contact.displayName"
          onChangeNotStopping={handleDisplayNameChange}
        />
      </Grid>
      <Grid size={3}>
        <TextFormField
          disabled={isDisabled}
          label={t('form.companyPosition')}
          name="contact.companyPosition"
        />
      </Grid>
      {!isEditing && (
        <>
          <Grid size={3}>
            <PhoneFormField disabled={isDisabled} label={t('form.phone')} name="contact.phone" />
          </Grid>
          <Grid size={3}>
            <TextFormField disabled={isDisabled} label={t('form.email')} name="contact.email" />
          </Grid>
        </>
      )}
      <Grid size={3}>
        <SelectSearchFormField
          disabled={isDisabled}
          label={t('form.status')}
          name="contact.status"
          options={contactStatusOptions}
        />
      </Grid>
      {hideOwner !== true && (
        <Grid size={3}>
          <SelectSearchFormField
            disabled={isDisabled}
            label={t('form.contactOwnerId')}
            name="contact.contactOwnerId"
            options={USERS_SHORT}
          />
        </Grid>
      )}
      <Grid size={12}>
        <TextFormField
          disabled={isDisabled}
          label={t('form.note')}
          minRows={2}
          multiline
          name="contact.note"
        />
      </Grid>
    </Grid>
  );
};
